import invariant from 'tiny-invariant'
import type { ApiError } from '../../utils/api-client/api-error.ts'
import { CreateProjectRequestSchema } from '../../utils/api-client/api-schemas.ts'

/**
 * The field limits, read off the request schema rather than restated.
 *
 * The inputs enforce what the schema would reject, so a limit that changes in the contract reaches the
 * form by itself. Restating them meant a parse failure the author met as "Unexpected issue" if the two
 * ever drifted. `UpdateProjectRequestSchema` carries the same limits, so either is a valid source.
 */
const nameMaxLength = CreateProjectRequestSchema.shape.name.maxLength
const descriptionMaxLength = CreateProjectRequestSchema.shape.description.unwrap().maxLength
invariant(nameMaxLength !== null, 'CreateProjectRequest.name is expected to carry a maximum length')
invariant(descriptionMaxLength !== null, 'CreateProjectRequest.description is expected to carry a maximum length')

export const PROJECT_NAME_MAX_LENGTH = nameMaxLength
export const PROJECT_DESCRIPTION_MAX_LENGTH = descriptionMaxLength

/** The problem both the create and the edit endpoints raise for a name another project already has. */
export const DUPLICATE_PROJECT_PROBLEM_TYPE = 'pixee:problems/api/projects/duplicate-name'

/**
 * Whether a refusal was a name clash.
 *
 * Only the typed problem counts. The technical spec reserves meaning for an untyped 409 to the
 * feedback endpoint; here a 409 the client cannot match falls back to the generic failure toast rather
 * than blaming the name field for a conflict it may not have caused.
 */
export const isDuplicateProjectNameError = (error: ApiError) =>
  error.status === 409 && error.problemType === DUPLICATE_PROJECT_PROBLEM_TYPE
